const action = 'SEGMENT_PREVIEW';
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE = action + '_FAILURE';
export const CLEAR = action + '_CLEAR';

/**
 * Request segment data preview using segment_id
 * @param {Object} payload - Payload with segment_id and pagination params
 */
export const previewSegmentByIdRequest = (payload) => ({
  type: REQUEST,
  source: 'segment_id',
  payload
});

/**
 * Request segment data preview using segment configuration
 * @param {Object} payload - Payload with segment config and pagination params
 */
export const previewSegmentByConfigRequest = (payload) => ({
  type: REQUEST,
  source: 'config',
  payload
});

/**
 * Success action for segment preview
 * @param {Object} payload - API response with segment data
 */
export const previewSegmentSuccess = (payload) => ({
  type: RESPONSE,
  payload
});

/**
 * Failure action for segment preview
 * @param {String} payload - Error message
 */
export const previewSegmentFailure = (payload) => ({
  type: FAILURE,
  payload
});

/**
 * Clear segment preview state
 */
export const clearPreviewState = () => ({
  type: CLEAR
});
